import styled from 'styled-components';

const MainGroupStyled = styled.div`
  .main_content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 4px;
  }
  .card_content {
    width: 49.9%;
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    margin-bottom: 4px;
  }
`;

export default MainGroupStyled;
